import { BaseEvents } from '@/shared/utils';
import { Profile } from './types/profile';

export const ProfileEventKeys = {
  profile: {
    view: 'profile/view',
    update: 'profile/update',
    delete: 'profile/delete',
    logout: 'profile/logout',
  },
  redirect: {
    to: 'redirect/to',
  },
} as const;

export interface ProfileEvents extends BaseEvents {
  'profile/view': { email: string; onSuccessCallback?: () => void };
  'profile/logout': void;
  'profile/update': Profile;
  'profile/delete': { email: string };
  'redirect/to': string;
}
